import { normalizeForSearch } from '@/shared/lib/search';
import type { ActionLogEntry } from '@/types';
import { getActionLogLabel } from './labels';

export const searchActionLogEntries = (
  entries: ActionLogEntry[],
  query: string
): ActionLogEntry[] => {
  const normalized = normalizeForSearch(query);
  if (!normalized) return entries;

  return entries.filter((entry) => {
    const { title, description } = getActionLogLabel(entry);
    const membershipName = 'membershipName' in entry ? entry.membershipName : undefined;

    return [title, description, membershipName, entry.kind].some((value) =>
      value?.toLowerCase().includes(normalized)
    );
  });
};
